import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFirmAccountAddOnMutationVariables = Types.Exact<{
  input: Types.CreateFirmAccountAddOnInput;
}>;


export type CreateFirmAccountAddOnMutation = { __typename?: 'Mutation', createFirmAccountAddOn: { __typename?: 'FirmAccountAddOnEntity', id: string, firmAccountId: string, addOnId: string, subscriptionId: string, subscriptionStatus?: Types.StripeSubscriptionStatus | null, subscriptionCancelAtPeriodEnd?: boolean | null, createAt: any, updateAt: any } };


export const CreateFirmAccountAddOnDocument = gql`
    mutation createFirmAccountAddOn($input: CreateFirmAccountAddOnInput!) {
  createFirmAccountAddOn(input: $input) {
    id
    firmAccountId
    addOnId
    subscriptionId
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
    createAt
    updateAt
  }
}
    `;
export type CreateFirmAccountAddOnMutationFn = Apollo.MutationFunction<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>;

/**
 * __useCreateFirmAccountAddOnMutation__
 *
 * To run a mutation, you first call `useCreateFirmAccountAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirmAccountAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirmAccountAddOnMutation, { data, loading, error }] = useCreateFirmAccountAddOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFirmAccountAddOnMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>(CreateFirmAccountAddOnDocument, options);
      }
export type CreateFirmAccountAddOnMutationHookResult = ReturnType<typeof useCreateFirmAccountAddOnMutation>;
export type CreateFirmAccountAddOnMutationResult = Apollo.MutationResult<CreateFirmAccountAddOnMutation>;
export type CreateFirmAccountAddOnMutationOptions = Apollo.BaseMutationOptions<CreateFirmAccountAddOnMutation, CreateFirmAccountAddOnMutationVariables>;
export const namedOperations = {
  Mutation: {
    createFirmAccountAddOn: 'createFirmAccountAddOn'
  }
}